import { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Image, Modal, Select } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { deleteForm, profileImage, searchSelectProps } from '../../components/helpers';
import churchForms from '../../services/api/churchForms';
import Swal from 'sweetalert2';
import experienceService from '../../services/api/experienceService';
import { ManuallyUpdateGuestLeaders } from './components/manuallyUpdateGuestLeaders';
import { ListsContext } from '../../services/contextProviders/lists/listsContext';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';

const ChecksComp = styled.div`
  border-bottom: 1px solid #b6b6b6;
  border-top: 1px solid #b6b6b6;
  padding: 10px 0;
  margin: 20px 0px;
  p {
    margin: 0;
  }
  .button {
    margin: 20px 0 0 0;
  }
`;

const NewVolunteerModal = (props) => {
  const { NewVolunteer = {}, set_showVolunteer, getInfo } = props;
  const {
    identification,
    name,
    lastName,
    phone,
    email,
    gender,
    serviceAreas,
    crecerlevel,
    promotedVolunteer,
    haveAGroup,
    GuestLeader,
    ocupation,
    civil,
    emergency_contact,
  } = NewVolunteer;
  const [inputs, set_inputs] = useState({});
  const [loading, set_loading] = useState(false);
  const { churchMinistries } = useContext(ListsContext);
  const getCaptchaToken = useRecaptchaToken('volunteer_form');

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    set_inputs({ ...inputs, [name]: value });
  };

  useEffect(() => {
    set_inputs({
      leadercheck: NewVolunteer.leadercheck,
      training: NewVolunteer.training,
      contacted: NewVolunteer.contacted,
      secondInterview: NewVolunteer.secondInterview,
    });
  }, [NewVolunteer]);

  const selectHandle = (a, { value, name }) => handleInputs({ target: { value, name } });

  const addVolunteer = async () => {
    set_loading(true);

    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_loading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    const guestId = parseInt(NewVolunteer.guest_id, 10);
    const birthdate = NewVolunteer.birthdate ? String(NewVolunteer.birthdate).slice(0, 10) : null;
    const body = {
      identification,
      phone,
      name,
      lastName,
      email,
      gender,
      ...(birthdate ? { birthdate } : {}),
      ...(Number.isInteger(guestId) ? { guest_id: guestId } : {}),
      role: 'Voluntario',
      section: 'Pendientes',
      serviceArea: inputs.serviceArea,
      ...(captchaRequired ? { captcha } : {}),
    };
    churchForms
      .volunteerForm(body)
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          Swal.fire(response.data.message);
          getInfo?.();
        } else if (response.data.message) {
          Swal.fire(response.data.message);
        }
      })
      .catch((error) => {
        set_loading(false);
        if (error && error.response.data) {
          Swal.fire(error.response.data.message);
        }
      });
  };

  const updateNewVolunteer = (extra = {}) => {
    set_loading(true);
    const body = {
      leadercheck: inputs.leadercheck,
      training: inputs.training,
      contacted: inputs.contacted,
      secondInterview: inputs.secondInterview,
      id: NewVolunteer.id,
      ...extra,
    };
    experienceService
      .UpdateNewVolunteersForm(body)
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          if (typeof extra.secondInterview === 'boolean') {
            set_inputs((prev) => ({ ...prev, secondInterview: extra.secondInterview }));
          }
          Swal.fire(response.data.message);
          getInfo?.();
        }
      })
      .catch((error) => {
        set_loading(false);
        if (error && error.response.data) {
          Swal.fire(error.response.data.message);
        }
      });
  };

  const toggleSecondInterview = () => {
    updateNewVolunteer({ secondInterview: !inputs.secondInterview });
  };

  return (
    <Modal open onClose={() => set_showVolunteer(null)}>
      <Modal.Header>
        Aspirante {name} {lastName}
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Image
            src={profileImage(NewVolunteer)}
            alt={`Foto_${name}_${lastName}`}
            rounded
            size="small"
          />
          <p style={{ margin: '15px 0' }}>
            <strong>Nombre: </strong>
            {name}
          </p>
          <p>
            <strong>Apellido: </strong>
            {lastName}
          </p>
          <p>
            <strong>Cédula: </strong>
            {identification}
          </p>
          <p>
            <strong>Teléfono: </strong>
            {phone}
          </p>
          <p>
            <strong>Email: </strong>
            {email}
          </p>
          <p>
            <strong>Genero: </strong>
            {gender}
          </p>
          <p>
            <strong>Estado civil: </strong>
            {civil}
          </p>
          <p>
            <strong>Ocupacion: </strong>
            {ocupation}
          </p>
          {serviceAreas?.length && (
            <p>
              <strong>Areas de interés: </strong>
              {serviceAreas?.replace(/_/g, ' ')}
            </p>
          )}
          <p>
            <strong>Pasos de crecer: </strong>
            {crecerlevel?.replace(/_/g, ' ')}
          </p>
          <Button
            primary
            onClick={() => {
              const win = window.open(
                `/perfil/crecer?identification=${identification || ''}&phone=${phone || ''}`,
                '_blank'
              );
              win.focus();
            }}
          >
            Ver perfil del discípulo
          </Button>
          <p>
            <strong>Tiene un grupo: </strong>
            {haveAGroup || GuestLeader?.leaderPhone ? 'Si' : 'No'}
          </p>
          {emergency_contact?.emergencyContactName && (
            <p>
              <strong>Contacto de emergencia: </strong>
              {emergency_contact.emergencyContactName} - {emergency_contact.emergencyContactPhone} -{' '}
              {emergency_contact.emergencyContactRelation}
            </p>
          )}
          {GuestLeader && (
            <p>
              <strong>Lider: </strong>
              <p>
                {GuestLeader.leaderFullName} - {GuestLeader.leaderPhone}
              </p>
            </p>
          )}
          <ManuallyUpdateGuestLeaders
            set_loading={set_loading}
            loading={loading}
            GuestLeader={GuestLeader}
            guest={NewVolunteer}
            getInfo={getInfo}
          />
          <p>
            {promotedVolunteer ? (
              <>
                <strong>Ingresado al equipo: </strong> {promotedVolunteer}
              </>
            ) : (
              'No'
            )}
          </p>
          <ChecksComp>
            <p>Aprobado por su líder</p>
            <Select
              placeholder={`Aprobad${gender === 'Masculino' ? 'o' : 'a'} por su líder`}
              style={{ margin: '0 0 20px 0' }}
              loading={loading}
              {...searchSelectProps({
                name: 'leadercheck',
                value: inputs?.leadercheck,
                handler: selectHandle,
                options: ['Sin Consultar', 'Aprobado', 'No aprobado'].map((a) => ({
                  key: a,
                  value: a,
                  text: a,
                })),
              })}
            />
            <div style={{ margin: '0 0 20px 0' }}>
              <Checkbox
                label="¿Confirmado para ir al entrenamiento?"
                name="contacted"
                checked={inputs.contacted}
                toggle
                onClick={() => set_inputs({ ...inputs, contacted: !inputs.contacted })}
              />
            </div>
            <div>
              <Checkbox
                label="¿Asistió al entrenamiento?"
                name="training"
                checked={inputs.training}
                toggle
                onClick={() => set_inputs({ ...inputs, training: !inputs.training })}
              />
            </div>
            <Button loading={loading} onClick={() => updateNewVolunteer()}>
              Enviar cambios
            </Button>
          </ChecksComp>
          {!promotedVolunteer && (
            <>
              <h2>Acciones</h2>
              <div style={{ margin: '0 0 20px 0' }}>
                <p style={{ margin: 0 }}>
                  Segunda entrevista <br />{' '}
                  <small>
                    {inputs.secondInterview
                      ? 'Este aspirante ya está marcado para segunda entrevista.'
                      : 'Esta acción marca al aspirante para la segunda entrevista.'}
                  </small>
                </p>
                <Button
                  loading={loading}
                  primary={!inputs.secondInterview}
                  onClick={toggleSecondInterview}
                >
                  {inputs.secondInterview
                    ? 'Quitar de segunda entrevista'
                    : 'Pasar a segunda entrevista'}
                </Button>
              </div>
              <p style={{ margin: 0 }}>
                Agregar a un equipo de experiencia <br />{' '}
                <small>
                  Esta acción agrega al voluntario a una lista y el coordinador debe introducirlo
                  activamente.
                </small>
              </p>
              <Select
                placeholder={'Area de Servicio'}
                style={{ margin: '0 0 20px 0' }}
                loading={loading}
                {...searchSelectProps({
                  name: 'serviceArea',
                  value: inputs?.serviceArea,
                  handler: selectHandle,
                  options: churchMinistries.map((opt) => ({
                    key: opt?.key,
                    value: opt?.key,
                    text: opt?.name,
                  })),
                })}
              />
              <Button loading={loading} onClick={addVolunteer}>
                Agregar
              </Button>
              <div>
                <p style={{ margin: 0 }}>
                  Sacar al aspirante <br />{' '}
                  <small>Esta acción oculta al aspirante de esta lista.</small>
                </p>
                <Button
                  loading={loading}
                  onClick={() =>
                    deleteForm({
                      subtitle: name,
                      Swal,
                      func: ({ text, successAlert }) => {
                        experienceService
                          .SDeleteNewVolunteersForm({ id: NewVolunteer.id, deleted: text })
                          .then((response) => {
                            if (response.data.success) {
                              successAlert();
                              getInfo();
                            } else {
                              Swal.fire(response.data.message);
                            }
                          })
                          .catch((error) => {
                            if (error.response) Swal.fire(error.response.data.message);
                          });
                      },
                    })
                  }
                >
                  Sacar
                </Button>
              </div>
            </>
          )}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => set_showVolunteer(null)} primary>
          Salir
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
export default NewVolunteerModal;
